import { createSlice } from "@reduxjs/toolkit";
import { ExportToPdf } from "../thunks/reportPdfThunks";

interface ReportPdfState {
  loading: boolean;
  error: string | null;
  success: boolean;
  downloadUrl: string | null;
  fileName: string | null;
}

const initialState: ReportPdfState = {
  loading: false,
  error: null,
  success: false,
  downloadUrl: null,
  fileName: null,
};

const reportPdfSlice = createSlice({
  name: "reportPdf",
  initialState,
  reducers: {
    resetPdfExport: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.downloadUrl = null;
      state.fileName = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ExportToPdf.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(ExportToPdf.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.downloadUrl = action.payload.downloadUrl || null;
        state.fileName = action.payload.fileName || null;
      })
      .addCase(ExportToPdf.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בייצוא PDF";
      });
  },
});

export const { resetPdfExport } = reportPdfSlice.actions;
export default reportPdfSlice.reducer;
